import React from 'react';
import css from './HireExperiencedList.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../../util/routes';
import { createSlug } from '../../../../../util/urlHelpers';
import { FormattedMessage } from 'react-intl';
import { skillTypeMapperSharetribe } from '../../../../../util/constants';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import { AvatarMedium, Button, NamedLink, ResponsiveImage } from '../../../../../components';

const createListingURL = (routes, listing) => {
  const id = listing.id.uuid;
  const slug = createSlug(listing.attributes.title);
  const linkProps = {
    name: 'ListingPage',
    params: { id, slug },
  };

  return createResourceLocatorString(linkProps.name, routes, linkProps.params, {});
};

function HireExperiencedList({ options, activeTab, params, isCurrentUserProfessional,
  isCurrentUserClient, }) {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const handleProfile = listing => {
    history.push(createListingURL(routeConfiguration, listing));
  };
  return (
    <div className={css.experiencedWrapper}>
      <div className={css.expHeading}>
        <FormattedMessage id="HireExperiencedList.heading" />
      </div>
      <div className={css.experiencedCardBox}>
        {(params.include && params.include.includes("projects")) || params.tab === "projects" || isCurrentUserProfessional
          ? options.projects.slice(0, 3).map((item) => {
            const { author, attributes, id } = item || {};
            const { title, publicData } = attributes || {};
            const { professionalSkills, cloudnaryImage, location } = publicData || {};
            const { displayName } = author.attributes.profile || {};
            return (
              <div className={css.experiencedCard} key={item?.id?.uuid}>
                {/* Image Section */}
                <div className={css.expImage}>
                  <ResponsiveImage
                    rootClassName={css.thumbImage}
                    url={cloudnaryImage[0]?.secure_url}
                    variants={['listing-card']}
                  />
                </div>

                {/* Profile Name */}
                <div className={css.profileName}>{title}</div>

                {/* Display Name */}
                <div className={css.professionName}>
                  {displayName ?? ""}
                </div>

                {/* Skills Section */}
                <div className={css.skillList}>
                  {professionalSkills?.slice(0, 5)?.map((skill, index) => {
                    const skillName = Object.entries(skillTypeMapperSharetribe)
                      .filter(([_, value]) => value === skill)
                      .map(([key]) => key)[0];
                    return skillName ? (
                      <span key={index} className={css.skillName}>
                        {skillName}
                      </span>
                    ) : null;
                  })}
                  {Array.isArray(professionalSkills) &&
                    professionalSkills.length > 5 ? (
                    <span className={css.totalCount}>
                      +{professionalSkills.length - 5}
                    </span>
                  ) : null}
                </div>

                {/* Location Section */}
                <div className={css.location}>
                  <div className={css.locationHeading}>
                    <FormattedMessage id="HireExperiencedList.service" />
                  </div>
                  <div className={css.locationName}>
                    <IconCard brand="cardlocation" />
                    {location.address ?? ""}
                  </div>
                </div>

                {/* View Profile Button */}
                <NamedLink
                  className={css.viewProfileButton}
                  name="ListingPage"
                  params={{ id: id.uuid, slug: title }}>
                  <FormattedMessage id="HireExperiencedList.viewListing" />
                </NamedLink>
              </div>
            );
          })
          : options.listings.slice(0, 3).map((item) => {
            const { author, attributes, id } = item || {};
            const { title, publicData } = attributes || {};
            const { professionalSkills, cloudnaryImage, location } = publicData || {};
            const { displayName } = author.attributes.profile || {};
            return (
              <div className={css.experiencedCard} key={item?.id?.uuid}>
                {/* Image Section */},
                <div className={css.postAvatar}>
                    <AvatarMedium  user={author} disableProfileLink />
                </div>

                {/* Profile Name */}
                <div className={css.profileNames}>{title}</div>

                {/* Display Name */}
                <div className={css.professionName}>
                  {displayName ?? ""}
                </div>

                {/* Skills Section */}
                <div className={css.skillList}>
                  {professionalSkills?.slice(0, 5)?.map((skill, index) => {
                    const skillName = Object.entries(skillTypeMapperSharetribe)
                      .filter(([_, value]) => value === skill)
                      .map(([key]) => key)[0];
                    return skillName ? (
                      <span key={index} className={css.skillName}>
                        {skillName}
                      </span>
                    ) : null;
                  })}
                  {Array.isArray(professionalSkills) &&
                    professionalSkills.length > 5 ? (
                    <span className={css.totalCount}>
                      +{professionalSkills.length - 5}
                    </span>
                  ) : null}
                </div>

                {/* Location Section */}
                <div className={css.location}>
                  <div className={css.locationHeading}>
                    <FormattedMessage id="HireExperiencedList.service" />
                  </div>
                  <div className={css.locationName}>
                    <IconCard brand="cardlocation" />
                    {location?.address ?? ""}
                  </div>
                </div>

                {/* View Profile Button */}
                <NamedLink
                  className={css.viewProfileButton}
                  name="ProfilePage" params={{ id: author.id.uuid }}>
                  <FormattedMessage id="HireExperiencedList.viewProfile" />
                </NamedLink>

              </div>
            );
          })}
      </div>
      <div className={css.buttonWrapper}>
        {params.tab == "projects" || isCurrentUserProfessional ?
          <NamedLink name="SearchPage"
            params={{ tab: 'projects' }}>
            <FormattedMessage id="SectionSearchBar.projects" />
          </NamedLink>
          :
          isCurrentUserClient ?
            <NamedLink name="SearchPage"
              params={{ tab: 'pros' }}>
              <FormattedMessage id="SectionSearchBar.pros" />
            </NamedLink>
            :
            <NamedLink name="SearchPage"
              params={{ tab: 'pros' }}>
              <FormattedMessage id="SectionSearchBar.pros" />
            </NamedLink>
        }
      </div>
    </div>
  );
}

export default HireExperiencedList;
